// extracted by mini-css-extract-plugin
export default {"container":"RecordInteraction_container__lXen-","left":"RecordInteraction_left__QZwAF","right":"RecordInteraction_right__FpyiT"};